<template>
  <Dialog title="新增消息" :visible.sync="dialogVisible" width="800px">
    <el-form ref="formRef" :model="form" label-width="100px" :rules="rules">
      <el-form-item label="标题" prop="title">
        <el-input
          v-model.trim="form.title"
          placeholder="请输入标题"
          maxlength="15"
        ></el-input>
      </el-form-item>
      <el-form-item label="接收学员" prop="recipientType">
        <el-select v-model="form.recipientType" placeholder="请选择接收学员">
          <el-option label="全部学员" :value="1"></el-option>
          <el-option label="指定学员" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="选择学员"
        prop="recipientMemberIds"
        v-if="form.recipientType == 2"
      >
        <el-transfer
          filterable
          v-model="form.recipientMemberIds"
          :data="studentList"
        ></el-transfer>
      </el-form-item>
      <el-form-item label="内容" prop="content">
        <el-input
          v-model.trim="form.content"
          maxlength="500"
          :rows="6"
          show-word-limit
          placeholder="请输入内容"
          type="textarea"
        ></el-input>
      </el-form-item>
      <el-form-item label="发送时间" prop="sendTime">
        <el-date-picker
          v-model="form.sendTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm"
          placeholder="选择日期时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item width="100%">
        <el-button plain round size="small" @click="handleClose"
          >关闭</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="primary"
          :loading="submitLoading"
          @click="submitForm"
          >提交</el-button
        >
      </el-form-item>
    </el-form>
  </Dialog>
</template>

<script>
import { getStudents } from "@/api/student";
import { addMessage } from "@/api/message";
export default {
  name: "MessageForm",
  data() {
    return {
      dialogVisible: false,
      form: {
        title: "",
        recipientType: "",
        content: "",
        sendTime: "",
        recipientMemberIds: []
      },
      studentList: [],
      submitLoading: false,
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        recipientMemberIds: [
          { required: true, message: "请选择接收学员", trigger: "blur" }
        ],
        recipientType: [{ required: true, message: "请选择", trigger: "blur" }],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }]
      }
    };
  },
  methods: {
    async open() {
      this.dialogVisible = true;
      this.form = {
        title: "",
        recipientType: "",
        content: "",
        sendTime: "",
        recipientMemberIds: []
      };
      const students = await getStudents({ pageNum: 1, pageSize: 9999 });
      const rows = (students.data && students.data.rows) || [];
      this.studentList = rows.map(item => {
        const name = item.name != null ? String(item.name).trim() : "";
        const phone = item.phone != null ? String(item.phone) : "";
        return {
          key: item.memberWechatId,
          label: name || phone || String(item.memberWechatId || "-")
        };
      });
    },
    async submitForm() {
      if (this.submitLoading) return;
      try {
        await this.$refs.formRef.validate();
      } catch (e) {
        return;
      }
      this.submitLoading = true;
      try {
        await addMessage(this.form);
        this.$message.success("新增成功");
        this.handleClose();
        this.$emit("success");
      } finally {
        this.submitLoading = false;
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.form = {
        title: "",
        recipientType: "",
        content: "",
        sendTime: "",
        recipientMemberIds: []
      };
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/Message/MessageForm.vue